import * as React from 'react';
import PriceHelper from '../../../helpers/PriceHelper';
import MarkupHelper from '../../../helpers/MarkupHelper';

const FlightPriceSelect = (props) => {

    let renderDiscount = (discount) => {
        if (discount === undefined || discount <= 0) {
            return null;
        }

        return (
            <span>
                &nbsp;
                <span className="d-none d-inline-block badge badge-danger">
                    -{discount}%
                </span>
            </span>
        );
    };

    const isSinglePassenger = () => {
        return PriceHelper.getPeopleCount(props.searchParams) === 1;
    };

    let renderPassengerPrice = (price) => {
        if (!props.mobile && isSinglePassenger()) {
            return null;
        }

        return (
            <span className="d-block d-lg-none ml-1 mr-1 ml-lg-0 mr-lg-0">
                <span className="d-inline">
                    <span className="flight-price-mobile" {...props.priceFormatter.formatParts(price)}/>
                </span>
            </span>
        );
    };

    const displayClass = 'd-block';
    const discount = renderDiscount(props.discount);

    let priceFromBlock = props.priceFormatter.formatParts((
        MarkupHelper.shouldHideOvercharge(props.flight.general.amountDisplay, props.agencySettings) ? props.averageFlightPricePerPerson + props.serviceFeePerPerson
            : props.averageFlightPricePerPerson), () => {
        if (props.flight.general.isFromTextVisible && isSinglePassenger()) {
            return `<span class="from-text">${props.translator.trans('from')}</span>`
        }
        return (
            `<span class="d-flex align-items-baseline">
                <span class="small flights-from-text">${props.translator.trans('from')}</span>
            </span>`
        )
    });

    if (props.mobile) {
        return (
            <React.Fragment>
                <div className="price-block-mobile">
                    {!MarkupHelper.shouldHideOvercharge(props.flight.general.amountDisplay, props.agencySettings) &&
                        <div className="small">
                            <span>{props.translator.trans('Service fee per person')}: </span>
                            <span {...props.priceFormatter.format(props.serviceFeePerPerson)}/>
                        </div>
                    }
                    <div className="small">
                        <span>{props.translator.trans('Final price per person')}: </span>
                        <span className="total-person-price" {...props.priceFormatter.format(props.averageFlightPricePerPerson + props.serviceFeePerPerson)}/>
                    </div>
                    {!!props.discount &&
                        <div className="small">
                            <span>{props.translator.trans('Discount')}: </span>
                            <span>-{props.discount}%</span>
                        </div>
                    }
                </div>
                <a
                    href={props.link}
                    className="btn btn-success button-right-rounded-corners text-white choose-button-mobile"
                    onClick={props.setLoading}
                    target="_parent"
                >
                    {MarkupHelper.shouldHideOvercharge(props.flight.general.amountDisplay, props.agencySettings) ?
                        renderPassengerPrice(props.averageFlightPricePerPerson + props.serviceFeePerPerson) :
                        renderPassengerPrice(props.averageFlightPricePerPerson)}
                </a>
            </React.Fragment>
        )
    }

    return (
        <div className={`text-left float-left float-lg-none ${displayClass}`}>
            <h2 className={`mb-0 mb-lg-3 font-weight-bold ${(discount || props.isCheapest()) ? 'text-danger' : ''}`}
                {...priceFromBlock}
            />
            {discount}
            <ul className="list-unstyled mt-0 mb-3 my-lg-3 text-left price-details">
                {!MarkupHelper.shouldHideOvercharge(props.flight.general.amountDisplay, props.agencySettings) &&
                    <li className="small text-muted">
                        <span>{props.translator.trans('Service fee per person')}: </span>
                        <span{...props.priceFormatter.format(props.serviceFeePerPerson)}/>
                    </li>
                }
                <li className="small text-muted">
                    <span>{props.translator.trans('Final price per person')}: </span>
                    <span{...props.priceFormatter.format(props.averageFlightPricePerPerson + props.serviceFeePerPerson)}/>
                </li>
            </ul>
        </div>
    );
};

export default FlightPriceSelect;



// WEBPACK FOOTER //
// ./src/components/flights/FlightCard/FlightPriceSelect.js